var map = {
	"./celery.png": 125,
	"./crustaceans.png": 126,
	"./dairy.png": 127,
	"./eggs.png": 128,
	"./fish.png": 129,
	"./gluten.png": 130,
	"./lupin.png": 131,
	"./molluscs.png": 132,
	"./mustard.png": 133,
	"./nuts.png": 134,
	"./peanuts.png": 135,
	"./sesame.png": 136,
	"./so2_sulfites.png": 137,
	"./soy.png": 138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;